export default function Hero() {
  const scrollToContact = () => {
    const element = document.getElementById('contact');
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section id="home" className="relative min-h-screen flex items-center overflow-hidden">
      <div className="absolute inset-0 bg-gradient-to-br from-[#1A2B4A] via-[#2A3B5A] to-[#00A8E8]">
        <div className="absolute inset-0 bg-gradient-to-b from-black/30 via-black/20 to-black/30"></div>
      </div>
      
      <img
        src="https://public.readdy.ai/ai/img_res/3fd561ed23e84269b8bd4a5074fe4aa8.jpg"
        alt="VPN Security Network"
        className="absolute inset-0 w-full h-full object-cover object-top opacity-40"
      />

      <div className="relative z-10 w-full max-w-7xl mx-auto px-8 py-32">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center">
          <div className="text-white">
            <h1 className="text-7xl font-bold leading-tight mb-8" style={{ fontFamily: 'Georgia, serif' }}>
              Secure Your Digital Freedom
            </h1>
            <p className="text-xl leading-relaxed mb-12 text-white/90">
              Experience unparalleled online privacy and security with SERGAS VPN. 
              Protect your data, bypass restrictions, and browse the internet with complete confidence.
            </p>
            <button
              onClick={scrollToContact}
              className="group relative inline-flex items-center gap-4 bg-gradient-to-r from-[#00A8E8] to-[#0088C8] text-white px-10 py-4 rounded-full text-lg font-semibold hover:shadow-2xl hover:scale-105 transition-all duration-300 whitespace-nowrap"
            >
              Get Protected Now
              <div className="flex items-center justify-center w-10 h-10 bg-white rounded-full">
                <i className="ri-arrow-right-line text-[#00A8E8] text-xl"></i>
              </div>
            </button>
          </div>

          <div className="hidden lg:block">
            <img
              src="https://readdy.ai/api/search-image?query=Modern%20abstract%203D%20illustration%20of%20VPN%20security%20technology%20with%20glowing%20shield%20hologram%20interconnected%20network%20nodes%20flowing%20encrypted%20data%20streams%20in%20vibrant%20cyan%20and%20blue%20gradients%20floating%20geometric%20shapes%20representing%20digital%20protection%20on%20soft%20gradient%20background%20tech%20innovation%20concept&width=800&height=800&seq=hero-visual-001&orientation=squarish"
              alt="VPN Security Illustration"
              className="w-full h-auto rounded-3xl shadow-2xl"
            />
          </div>
        </div>
      </div>
    </section>
  );
}
